import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { authHeader, config } from '../_helpers';
import { ListResources } from './ListResources';
import { ResourceDetails } from './ResourceDetails';
import { Profile } from './Profile';
import { EditProfile } from './EditProfile';
import { EditResource } from './EditResource';
import { CreateManifest } from '../Manifest/CreateManifest';
import { SortYourCrew } from '../Manifest/SortYourCrew';
import { VehicleList } from '../Manifest/VehicleList';
import { Finalize } from '../Manifest/Finalize';
import { ArchivedResourcesDetails } from './ArchivedResourcesDetails';
import { ListManifests } from './ListManifests';
import ResourceOrderForm from 'Docs/Forms/ResourceOrderForm/ResourceOrderForm';
import '../assets/styles/resource.css';
import { manifestService } from '_services';
import PropTypes from 'prop-types';

class Resources extends React.Component {
  constructor(props) {
    super(props);

    let step, id, isArchiveResources;
    if (this.props.match.path === '/resources/:id') {
      step = 'Details';
      id = this.props.match.params.id;
    } else if (this.props.match.path === '/resources/:id/listmanifests') {
      step = 'ListManifests';
      id = this.props.match.params.id;
    } else if (this.props.match.path === '/resource-profile/:hash/:step') {
      step = 'Profile';
      id = this.props.match.params.hash;
    } else {
      step = 'List';
      id = '';
    }

    if (this.props.match.path === '/archived-resources/:id') {
      isArchiveResources = true;
      id = this.props.match.params.id;
    }
    this.state = {
      mainHtml: '',
      step: step,
      button: '',
      props: id,
      hash: '',
      id: id,
      isArchiveResources,
      resource_id: '',
      manifest_id: '',
      contract_number_id: '',
      dispatch_location: '',
      prevtype: '',
      type: '',
      prev: false,
      vPrev: false,
      edit: false,
      permissions: [],
      redirect: '',
      ResourceOrderData: {},
      assignedManifest: false,
      assignedDateOn: null,
      assignedDateOff: null,
      originalVehicles: [],
      originalCrews: [],
      form: {},
    };
    this.changeTab = this.changeTab.bind(this);
    this.profile = this.profile.bind(this);
    this.editResource = this.editResource.bind(this);
    this.details = this.details.bind(this);
    this.createManifest = this.createManifest.bind(this);
    this.yourCrew = this.yourCrew.bind(this);
    this.goToType = this.goToType.bind(this);
    this.toVehicle = this.toVehicle.bind(this);
    this.goToCrew = this.goToCrew.bind(this);
    this.finalize = this.finalize.bind(this);
    this.goToVehicle = this.goToVehicle.bind(this);
    this.editManifest = this.editManifest.bind(this);
    this.viewManifest = this.viewManifest.bind(this);
    this.goBackDetails = this.goBackDetails.bind(this);
    this.editProfile = this.editProfile.bind(this);
  }

  changeTab(tab) {
    this.setState({ step: tab }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  details(props) {
    this.setState(
      { step: 'Details', props: props, edit: false, prev: false },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  profile(hash) {
    this.setState({ step: 'Profile', hash: hash }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  editProfile(hash) {
    this.setState({ step: 'EditProfile', hash: hash }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  editResource(id) {
    this.setState({ step: 'Edit', id: id }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  createManifest() {
    this.setState({ step: 'CreateManifest' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  yourCrew(type, contract_number_id, dispatch_location) {
    this.setState(
      { step: 'SortYourCrew', type, contract_number_id, dispatch_location },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  goToType(type) {
    this.setState(
      { step: 'CreateManifest', prevtype: type, prev: false },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  goToCrew(crews) {
    this.setState(
      { step: 'SortYourCrew', savedCrews: crews, prev: true },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  toVehicle(crews) {
    this.setState(
      { step: 'VehicleList', savedCrews: crews, crews: crews },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  goToVehicle(crews, form) {
    this.setState(
      {
        step: 'VehicleList',
        crews: crews,
        form: form,
        vPrev: true,
        assignedManifest: this.state.assignedManifest,
      },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  storeAssignedStatus(status) {
    this.setState({ assignedManifest: status });
  }

  storeAssignedDateOff(date_off) {
    this.setState({ assignedDateOff: date_off });
  }

  storeAssignedDateOn(date_on) {
    this.setState({ assignedDateOn: date_on });
  }

  storeOriginalVehicles(vehicles) {
    this.setState({ originalVehicles: vehicles });
  }

  storeOriginalCrews(crews) {
    this.setState({ originalCrews: crews });
  }

  finalize(vehicles) {
    this.setState(
      {
        vehicles: vehicles,
        originalVehicles: vehicles,
      },
      () => {
        // After vehicles are updated
        this.setState({ step: 'Finalize' }, () => {
          // After step is updated
          this.componentWillReceiveProps(this.props);
        });
      },
    );
  }
  goBackDetails() {
    this.setState({ step: 'List', prev: false }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  editManifest(id, type) {
    this.setState(
      { step: 'SortYourCrew', manifest_id: id, type, edit: true },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  duplicateManifest(manifest) {
    // Extract the correct properties from the manifest object
    const manifestId = manifest.manifestId || manifest.manifest_id || manifest.mid || manifest.id;
    const manifestVersionId = manifest.manifestVersionId || manifest.manifest_version_id || manifest.version_id || manifest.versionId;
    
    if (!manifest || !manifestId) {
      console.error('Invalid manifest data provided to duplicateManifest:', manifest);
      return;
    }


    const data2 = new FormData();
    data2.append('manifest_id', manifestId);
    if (manifestVersionId) {
      data2.append('manifest_version_id', manifestVersionId);
    }

    const data3 = new FormData();
    data3.append('resource_id', this.state.id);
    data3.append('manifest_id', manifestId);
    if (manifestVersionId) {
      data3.append('manifest_version_id', manifestVersionId);
    }
    data3.append('base_manifest_type', manifest.baseManifestId || manifest.bid || manifest.base_manifest_id);

    const data4 = new FormData();
    data4.append('resource_id', this.state.id);
    data4.append('manifest_id', manifestId);
    if (manifestVersionId) {
      data4.append('manifest_version_id', manifestVersionId);
    }

    Promise.all([
      manifestService.manifestDetails(data2),
      manifestService.getUsers(data3),
      manifestService.getVehicles(data4),
    ])
      .then(([detailsResponse, usersResponse, vehiclesResponse]) => {    
        const manifestDetails = detailsResponse.data;
        
        // Ensure vehicles is an array
        const vehiclesData = Array.isArray(vehiclesResponse.data) 
          ? vehiclesResponse.data 
          : [];
        
        // Ensure crews is an array
        const crewsData = Array.isArray(usersResponse.data) 
          ? usersResponse.data 
          : [];
        
        this.setState(
          {
            type: manifestDetails.base_manifest_id,
            contract_number_id: manifestDetails.contract_number_id,
            dispatch_location: manifestDetails.dispatch_location,
            assignedManifest: false,
            assignedDateOff: false,
            assignedDateOn: false,
            crews: crewsData,
            savedCrews: crewsData,
            originalCrews: crewsData,
            vehicles: vehiclesData,
            originalVehicles: vehiclesData,
            step: 'Finalize',
          },
          () => {
            this.componentWillReceiveProps(this.props);
          },
        );
      })
      .catch((error) => {
        console.error('Error duplicating manifest:', error);
        // Set default empty arrays to prevent PropTypes errors
        this.setState({
          crews: [],
          savedCrews: [],
          originalCrews: [],
          vehicles: [],
          originalVehicles: [],
          step: 'Finalize',
        });
        // You might want to show a toast notification here
        // toast.error('Failed to duplicate manifest. Please try again.');
      });
  }

  editRof(roData) {
    this.setState(
      { step: 'CreatedRO', ResourceOrderData: roData },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  viewManifest(id, type) {
    this.setState(
      { step: 'ViewManifest', manifest_id: id, type: type },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  componentDidMount() {
    if (localStorage.getItem('user') === null) {
      this.setState({
        redirect: '/login',
      });
    }
    this.componentWillReceiveProps(this.props);
    const self = this;
    fetch(config.apiUrl + '/api/permission/getuserpermissions', {
      headers: authHeader(),
      method: 'GET',
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        self.setState({ permissions: data.data });
      })
      .catch((err) => console.log(err));
  }

  componentWillReceiveProps(nextProps) {
    // Handle route change from ListManifests to Details
    let currentStep = this.state.step;
    let currentId = this.state.id;
    
    if (nextProps.match.path === '/resources/:id' && this.props.match.path === '/resources/:id/listmanifests') {
      const resourceId = nextProps.match.params.id;
      currentStep = 'Details';
      currentId = resourceId;
      this.setState({
        step: 'Details',
        props: resourceId,
        id: resourceId,
      });
    }

    var options;
    if (currentStep === 'List') {
      let assignmentStatus =
        this.props.location.state?.assignmentStats
          ? this.props.location.state.assignmentStats
          : '';
      options = (
        <div>
          <ListResources
            details={this.details.bind(this)}
            assignmentStatus={assignmentStatus}
          />
        </div>
      );
    }

    if (currentStep === 'Details') {
      options = (
        <div>
          <ResourceDetails
            goBack={this.changeTab.bind(this, 'List')}
            props={currentId}
            resourceId={currentId}
            profile={this.profile.bind(this)}
            editResource={this.editResource.bind(this)}
            createManifest={this.createManifest.bind(this)}
            editManifest={this.editManifest.bind(this)}
            duplicateManifest={this.duplicateManifest.bind(this)}
            viewManifest={this.viewManifest.bind(this)}
            details={this.details.bind(this)}
            editRof={this.editRof.bind(this)}
          />
        </div>
      );
    }

    if (currentStep === 'ListManifests') {
      options = (
        <div>
          <ListManifests
            goBack={this.changeTab.bind(this, 'List')}
            resourceId={currentId}
            props={currentId}
            viewManifest={this.viewManifest.bind(this)}
            editManifest={this.editManifest.bind(this)}
          />
        </div>
      );
    }


    if (this.state.step === 'Profile') {
      options = (
        <div>
          <Profile
            {...this.props}
            goBack={this.details.bind(this)}
            props={this.state.props}
            hash={this.state.hash}
            resourceDetails={this.state.props}
            id={this.state.id}
            editProfile={this.editProfile}
            toResourceList={this.goBackDetails}
          />
        </div>
      );
    }

    if (this.state.step === 'EditProfile') {
      options = (
        <div>
          <EditProfile
            goBack={this.profile.bind(this)}
            hash={this.state.hash}
            resourceDetails={this.state.props}
            toResourceList={this.goBackDetails}
            id={this.state.id}
          />
        </div>
      );
    }

    if (this.state.step === 'Edit') {
      options = (
        <div>
          <EditResource
            goBack={this.details.bind(this)}
            id={this.state.props}
          />
        </div>
      );
    }

    if (this.state.step === 'CreateManifest') {
      options = (
        <div>
          <CreateManifest
            yourCrew={this.yourCrew}
            props={nextProps}
            type={this.state.prevtype}
            contract_number_id={this.state.contract_number_id}
            cancel={this.details.bind(this)}
          />
        </div>
      );
    }

    if (this.state.step === 'SortYourCrew') {
      options = (
        <div>
          <SortYourCrew
            resource={this.state.props}
            type={this.state.type}
            previous={this.goToType}
            next={this.toVehicle.bind(this)}
            assignedManifest={this.state.assignedManifest}
            assignedDateOn={this.state.assignedDateOn}
            assignedDateOff={this.state.assignedDateOff}
            originalCrews={this.state.originalCrews}
            storeAssignedManifest={this.storeAssignedStatus.bind(this)}
            storeAssignedDateOn={this.storeAssignedDateOn.bind(this)}
            storeAssignedDateOff={this.storeAssignedDateOff.bind(this)}
            storeOriginalCrews={this.storeOriginalCrews.bind(this)}
            crews={this.state.crews}
            savedCrews={this.state.savedCrews}
            prev={this.state.prev}
            edit={this.state.edit}
            manifest_id={this.state.manifest_id}
            cancel={this.details.bind(this)}
          />
        </div>
      );
    }

    if (this.state.step === 'CreatedRO') {
      options = (
        <div>
          <div className='applicants_container sort_your_crew'>
            <div className='breadcrumbs'>
              <Link to={'/resources'} className='green'>
                Resources
              </Link>{' '}
              / <span onClick={this.details.bind(this)}>Details</span> / Edit
              Resource Order
            </div>
            <div className='page_title float'>
              <h1>Edit Resource Order</h1>
            </div>
          </div>
          <ResourceOrderForm
            resourceDetails={this.state.props}
            editMode={true}
            rofData={this.state.ResourceOrderData}
            onSubmit={this.details.bind(this)}
            onCancel={this.details.bind(this)}
          />
        </div>
      );
    }

    if (this.state.step === 'VehicleList') {
      options = (
        <div>
          <VehicleList
            type={this.state.type}
            savedCrews={this.state.savedCrews}
            resource={this.state.props}
            previous={this.goToCrew.bind(this)}
            next={this.finalize.bind(this)}
            assignedManifest={this.state.assignedManifest}
            assignedDateOn={this.state.assignedDateOn}
            assignedDateOff={this.state.assignedDateOff}
            originalVehicles={this.state.originalVehicles}
            storeAssignedManifest={this.storeAssignedStatus.bind(this)}
            storeAssignedDateOn={this.storeAssignedDateOn.bind(this)}
            storeAssignedDateOff={this.storeAssignedDateOff.bind(this)}
            storeOriginalVehicles={this.storeOriginalVehicles.bind(this)}
            SelVehicles={this.state.vehicles}
            prev={this.state.vPrev}
            edit={this.state.edit}
            manifest_id={this.state.manifest_id}
            cancel={this.details.bind(this)}
          />
        </div>
      );
    }

    if (this.state.step === 'Finalize') {
      options = (
        <Finalize
          crews={this.state.crews}
          resourceDetails={this.state.props}
          vehicles={this.state.vehicles}
          details={this.details.bind(this)}
          manifestType={this.state.type}
          contract_number_id={this.state.contract_number_id}
          dispatch_location={this.state.dispatch_location}
          previous={this.goToVehicle.bind(this)}
          edit={this.state.edit}
          form={this.state.form}
          manifest_id={this.state.manifest_id}
        />
      );
    }

    if (this.state.step === 'ViewManifest') {
      const { history } = this.props;
      history.push(
        `/resources/${this.state.id}/manifest/${this.state.manifest_id}`,
      );
    }

    if (this?.state?.isArchiveResources) {
      options = (
        <div>
          <ArchivedResourcesDetails
            goBack={this.changeTab.bind(this, 'List')}
            props={this.state.props}
            profile={this.profile.bind(this)}
            editResource={this.editResource.bind(this)}
            createManifest={this.createManifest.bind(this)}
            editManifest={this.editManifest.bind(this)}
            viewManifest={this.viewManifest.bind(this)}
            details={this.details.bind(this)}
          />
        </div>
      );
    }

    this.setState({ mainHtml: options });
  }

  render() {
    if (this.state.redirect === '/login') {
      return <Redirect to='/login' />;
    }
    const { permissions } = this.state;
    return (
      permissions.length > 0 &&
      (!permissions.includes('Manage Resources') ? (
        <div className='content_div'>
          <div className='no_permission'>No permission to this page</div>
        </div>
      ) : (
        <div className='hello-world'>{this.state.mainHtml}</div>
      ))
    );
  }
}

Resources.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  permission: PropTypes.object,
  location: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const { vehicles } = state;
  return {
    vehicles,
  };
}

const connectedResourcePage = connect(mapStateToProps)(Resources);
export { connectedResourcePage as Resources };
